module.exports = __webpack_public_path__ + "static/img/7.23fd04a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/01/7.png
// module id = Tuni
// module chunks = 1